export function isEmailValid(email: string): boolean {
  // Regular expression for a simple email validation
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

  return emailRegex.test(email);
}
